import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { Badge, badgeDotClasses } from 'Components/primitives/badge/index';
import { cn } from 'Components/primitives/utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'EnBadge',
    props: {
        state: { type: null, required: false, default: 'default' },
        variant: { type: String, required: false, default: 'colored' },
        size: { type: null, required: false, default: 'default' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        staticId: { type: [String, Number, null], required: false, default: null },
        dot: { type: Boolean, required: false, default: undefined }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // When dot is not explicitly set, outline variant shows the dot, colored does not.
        const showDot = computed(() => props.dot ?? props.variant === 'outline');
        const __returned__ = { props, showDot, get Badge() { return Badge; }, get badgeDotClasses() { return badgeDotClasses; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
